import IPageSourceResponse from '@/interfaces/IPageSourceResponse';
import { useNotificationStore } from '@/store/notificationStore';

export function parsePageSourceResponse(data: string): IPageSourceResponse {
    const notificationStore = useNotificationStore();
    try {
        return JSON.parse(data) as IPageSourceResponse;
    } catch (error) {
        notificationStore.addErrorNotification(`Failed to parse page source response: ${error}`);
        return {
            status: 'error',
            data: {
                httpStatusCode: 0,
                httpResponse: '',
            },
        };
    }
}
